import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { emptySAR } from '~bank-bsa-reporting/constants'
import { SarEdit } from '~bank-bsa-reporting/types'

import { BankAccounts, TIN } from './fields'

export const InstitutionInfo = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.institutionsInfo`
  })

  return (
    <>
      {fields.map((field, index2) => (
        <InstitutionInfoItem
          index1={index}
          index2={index2}
          key={field.id}
          rowsNumber={fields.length}
          onDelete={remove}
        />
      ))}

      <IconButton icon={IconName.ADD_GREEN} onClick={() => append(emptySAR.subjectsInfo[0].institutionsInfo[0])} />
    </>
  )
}

const InstitutionInfoItem = ({
  index1,
  index2,
  rowsNumber,
  onDelete
}: {
  index1: number
  index2: number
  rowsNumber: number
  onDelete: (index: number) => void
}) => {
  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => {
      onDelete(index2)
    },
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <FormRow>
        <Col>
          <TIN index1={index1} index2={index2} />
        </Col>
      </FormRow>
      <BankAccounts index1={index1} index2={index2} />
      <FormRow>
        {rowsNumber > 1 && <IconButton face="negative" icon={IconName.DELETE} onClick={startDeleting} />}
      </FormRow>
    </>
  )
}
